const {registerBlockType} = wp.blocks;
const {PanelBody, RangeControl} = wp.components;
const {InspectorControls, RichText, URLInputButton} = wp.blockEditor;
const {useEffect, useState} = wp.element;
const {apiFetch} = wp;

// import newsSlider from '../../../resources/scripts/module/news-slider';

registerBlockType('mailmetrics/news', {
  title: 'Latest News',
  icon: 'megaphone',
  category: 'widgets',
  attributes: {
    headingText: {
      type: 'string',
      default: 'News & Insights'
    },
    seeMoreUrl: {
      type: 'string',
      default: '',
    },
    seeMoreText: {
      type: 'string',
      default: 'See more',
    },
    numberOfPosts: {
      type: 'number',
      default: 3
    },
  },
  edit: ({attributes, setAttributes, isSelected}) => {
    const {numberOfPosts} = attributes;
    const [latestPosts, setLatestPosts] = useState([]);
    const initialDelay = 300;
    let currentDelay = initialDelay;

    useEffect(() => {
      if (!latestPosts || !latestPosts.length) {
        return;
      }

      // newsSlider();
    }, [latestPosts]);

    const incrementDelay = () => {
      currentDelay += 200;
      return currentDelay;
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleString('default', {month: 'long', year: 'numeric'});
    };

    useEffect(() => {
      apiFetch({path: `/wp/v2/posts?per_page=${numberOfPosts}&_embed`})
        .then((posts) => {
          setLatestPosts(posts);
        })
        .catch(() => {
          setLatestPosts([]);
        });

    }, [numberOfPosts]);

    return (
      <div>
        {isSelected && (
          <InspectorControls>
            <PanelBody title="Settings">
              <RangeControl
                label="Number of News Items"
                value={attributes.numberOfPosts}
                onChange={(newCount) => setAttributes({numberOfPosts: newCount})}
                min={1}
                max={10}
              />
            </PanelBody>
          </InspectorControls>
        )}
        <div className="news-section">
          <div className="inner">
            <div>
              <div className="section-header">
                <RichText
                  tagName="h1"
                  value={attributes.headingText}
                  onChange={(newText) => setAttributes({headingText: newText})}
                  placeholder="Enter heading..."
                />
                <a href={'#'} className={'accordion-content-url'} title={attributes.seeMoreUrl}>
                  <RichText
                    tagName="span"
                    value={attributes.seeMoreText}
                    onChange={(newSeeMoreText) => setAttributes({seeMoreText: newSeeMoreText})}
                  />
                  <URLInputButton
                    url={attributes.seeMoreUrl}
                    onChange={(newUrl) => setAttributes({seeMoreUrl: newUrl})}
                  />
                </a>
              </div>
              <div className="section-content">
                <div className="news-section-slider">
                  {latestPosts.length ? (
                    latestPosts.map((post) => {
                      const featuredImage = post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0] && post._embedded['wp:featuredmedia'][0].source_url;
                      const postDate = formatDate(post.date);
                      const categories = post._embedded && post._embedded['wp:term'] && post._embedded['wp:term'][0];
                      let categoryDisplay = '';

                      if (categories && categories.length > 0) {
                        const categoryName = categories[0].name;
                        categoryDisplay = (categoryName.toLowerCase() !== 'uncategorized') ? `${categoryName} | ` : '';
                      }

                      const delayForThisItem = incrementDelay();

                      return (
                        <div key={post.id} className="news-section-slider-item" data-aos="fade-up"
                             data-aos-delay={delayForThisItem} data-aos-duration="500" data-aos-offset="300">
                          <p className="news-section-slider-item-date">{`${categoryDisplay}${postDate}`}</p>
                          <h4 dangerouslySetInnerHTML={{__html: post.title.rendered}}/>
                          <div className="news-section-slider-item-bottom">
                            <a href={post.link}>Read more</a>
                            {featuredImage && <img src={featuredImage} alt={post.title.rendered}/>}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p>Loading latest news...</p>
                  )}
                </div>
                {/* <div className="news-section-slider-progress-bar">
                  <div className="news-section-slider-progress-bar-progress"></div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
  save: () => null,
});
